  $(document).on('change', "#user_group", function(){
    window.location = this.value
  })
  $(document).on('turbolinks:load', function () {
    $('.timepicker').timepicker({
      'timeFormat': 'h:i A',
      'step': 30,
      'forceRoundTime': true
    });

    $('.timepicker-without-roundoff').timepicker({
      'timeFormat': 'h:i A',
      'step': 30,
    })
  });

  $(document).on('change', '.select_check', function(){
    var category_id = $(this).data('category-id');
    console.log('call')
    var check_class = $(this).data('check-class')
    console.log(check_class)
      if($('input'+check_class +':checkbox:checked').length == $('input'+check_class+':checkbox').length){
      $("input[data-id="+check_class.replace('.', '')+"]").prop('checked',true);
    }else{
      $('input[data-id="modifier"]').prop('checked',true);
      $("input[data-id="+check_class.replace('.', '')+"]").prop('checked',false);
    }
    $('.category_count_check_' + category_id).text($('#itemmodal_' + category_id).find('.category_selection_' + category_id).filter(':checked').length);
  })

  $(document).on('keyup keypress change', '.phone-number', function (e) {
    phone_number = /^(1\s?)?((\([0-9]{3}\)-)|[0-9]{3})[\s\-]?[\0-9]{3}-[\s\-]?[0-9]{4}$/
    space_regex = /\(?\d{3}\)?[ ]\d{3}?[ ]\d{4}/
    dash_regex = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/
    var curchr = this.value.length;
    var curval = $(this).val();
    if (curchr == 3 && curval.indexOf("(") <= -1) {
      if (e.which != 8) {
        $(this).val("(" + curval + ")" + " ");
      }
    } else if (curchr == 4 && curval.indexOf("(") > -1) {
      if (e.which != 8) {
        $(this).val(curval + ")-");
      }
    } else if (curchr == 5 && curval.indexOf(")") > -1) {
      if (e.which != 8) {
        $(this).val(curval + "-");
      }
    } else if (curchr == 9) {
      if (e.which != 8) {
        $(this).val(curval + "-");
      }
      $(this).attr('maxlength', '14');
    } else if (curchr == 10 && curval.indexOf("(") != 0) {
      if (e.which != 8) {
        $(this).val("(" + curval.slice(0, 3) + ")" + " " + curval.slice(3, 6) + "-" + curval.slice(6, 10))
      }
      $(this).attr('maxlength', '14');
      $(this).parsley().validate();
    }
  });

  $(document).on('change', '.image-select', function (event) {
    
    
    if (event.target.parentElement.children[0].tagName == "IMG") {
      var image = document.getElementById(event.target.parentElement.children[0].id);
    } else {
      var image = document.getElementById("item-image");
      var plus = document.getElementById('item-plus');
    }
    if (plus && image) {
      plus.classList.remove('fa-plus')
      image.src = window.webkitURL.createObjectURL(event.target.files[0]);
    } else if (image) {
      image.src = window.webkitURL.createObjectURL(event.target.files[0]);
    }
  });

  $(document).on('click', '.hide_show_filter', function () {
    filter_id = "#" + $(this).data('id')
    if ($(this).prop('checked') == false) {
      $(filter_id).parents().parent('.filter_btn').hide()
    } else {
      $(filter_id).parent().parent('.filter_btn').show()
    }
  })


  $(document).off('change.dateFilter', '.filter-date').on('click', '.btn-modal', function () {
    if ($(this).hasClass("done")) date_filter_report();
    // Select the hidden "Custom Date Range " option when the page has it, because with the visible one selected, clicking the dropdown reopens the modal and Today/Yesterday can't be picked.
    $("#date_filter").val($("#date_filter option[value='Custom Date Range ']").length ? "Custom Date Range " : "Custom Date Range");
    //  $("#date_filter").val("Custom Date Range");
  })

  $(document).on('change', '.filter-date', function () {
    console.log($("option:selected", $(this)))
    if ($("option:selected", $(this)).text() == "Custom Date Range") {
      $("#customedateFilter").modal('show');
    } else {
      date_filter_report()
    }
  })
  // No click handler on the select: on some browsers a click fires when the dropdown opens, which showed the custom-range modal before any option was picked; the change handler above acts on the chosen option.
  // var selectedOption = "";
  // $(document).off('change.dateFilter', '.filter-date').on('click', '.filter-date', function () {
  //   console.log('change1', 'filter-date 1')
  //   var currentOption = $("option:selected", this).text();
  //   if (currentOption === "Custom Date Range") {
  //     $("#customedateFilter").modal('show');
  //   }
  //   selectedOption = currentOption;
  // });


  $(document).on('click', '.next-date', function () {
    browser_url = $(location).attr("href")
    if (browser_url.includes("sales_overview")) {
      req_url = "/reports/sales_overview"
    } else if (browser_url.includes("discounts")) {
      req_url = "/reports/discounts"
    } else if (browser_url.includes("gift_card_dashboard")) {
      req_url = "/gift_card_dashboard"
    } else if (browser_url.includes("hourly_sales_report")) {
      req_url = "/reports/hourly_sales_report"
    } else {
      req_url = "/reports/sales_report"
    }
    $.ajax({
      url: req_url,
      type: "GET",
      data: {
        date_filter: $.trim($('#date_filter').val()), // Trim so the hidden "Custom Date Range " option still matches 'Custom Date Range' on the server.
        terminal_id: $("#terminal").val(),
        employee_id: $("#employee").val(),
        order_type_id: $("#order_type").val(),
        next_start_date: $('#next_start_date').val(),
        prev_end_date: $('#prev_end_date').val(),
        next: true
      },
      dataType: "script"
    });
  });

  $(document).on('click', '.prev-date', function () {
    browser_url = $(location).attr("href")
    if (browser_url.includes("sales_overview")) {
      req_url = "/reports/sales_overview"
    } else if (browser_url.includes("discounts")) {
      req_url = "/reports/discounts"
    } else if (browser_url.includes("gift_card_dashboard")) {
      req_url = "/gift_card_dashboard"
    } else if (browser_url.includes("hourly_sales_report")) {
      req_url = "/reports/hourly_sales_report"
    } else {
      req_url = "/reports/sales_report"
    }
    $.ajax({
      url: req_url,
      type: "GET",
      data: {
        date_filter: $.trim($('#date_filter').val()), // Trim so the hidden "Custom Date Range " option still matches 'Custom Date Range' on the server.
        terminal_id: $("#terminal").val(),
        employee_id: $("#employee").val(),
        order_type_id: $("#order_type").val(),
        next_start_date: $('#next_start_date').val(),
        prev_end_date: $('#prev_end_date').val(),
        next: false
      },
      dataType: "script"
    });
  });

  function date_filter_report() {
    console.log("date_filter_report")
    browser_url = $(location).attr("href")
    console.log(browser_url)
    if (browser_url.includes("sales_overview")) {
      req_url = "/reports/sales_overview"
    } else if (browser_url.includes("discounts")) {
      req_url = "/reports/discounts"
    } else {
      req_url = "/reports/sales_report"
    }
    let date_filter_value = ($('#date_filter').val() == "Custom Date Range ") ? "Custom Date Range" : $('#date_filter').val();
    
    var params = {
      date_filter: date_filter_value,
      terminal_id: $("#terminal").val(),
      employee_id: $("#employee").val(),
      order_type_id: $("#order_type").val(),
      start_date: $("#start_date").val(),
      end_date: $("#end_date").val()
    };

      // If element not present → skip date logic
      var $dateEl = $('.d-flex.align-items-center.my-2.mr-3 p');
      if ($dateEl.length > 0) {
        var dateText = $dateEl.text().trim();

        if (dateText.includes(' - ')) {
          // Split dates
          var dates = dateText.split(' - ');
          var prevEndDate   = dates[0].trim();
          var nextStartDate = dates[1].trim();

          // Add only if present
          if (prevEndDate) {
            params.prev_end_date = prevEndDate;
          }

          if (nextStartDate) {
            params.next_start_date = nextStartDate;
          }
        }
      }

    $.ajax({
      url: req_url,
      type: "GET",
      data: params,
      // {
      //   date_filter: params,
      //   terminal_id: $("#terminal").val(),
      //   employee_id: $("#employee").val(),
      //   order_type_id: $("#order_type").val(),
      //   start_date: $("#start_date").val(),
      //   end_date: $("#end_date").val()
      // },
      dataType: "script",
      success: function (data) {
        $("#customedateFilter").modal('hide');
      }
    })
  }

  $(document).on('turbolinks:load', function () {
    $('#start_date').datetimepicker({
      format: 'MMMM-DD-YYYY hh:mm A',
      icons: {
        time: "fas fa-clock",
        date: "fa fa-calendar",
        up: "fa fa-arrow-up",
        down: "fa fa-arrow-down",
        previous: "fa fa-chevron-left",
        next: "fa fa-chevron-right",
        today: "fas fa-clock",
        clear: "fa fa-trash-o"
      }
    }).on('dp.change', function(e) {
      $(".day").on('click', function(){
        $("a[data-action='togglePicker']").trigger('click');
      });
      $('#end_date').data("DateTimePicker").minDate(e.date);  
    });
    $('#end_date').datetimepicker({
      format: 'MMMM-DD-YYYY hh:mm A',
      maxDate: new Date().setHours(23,59,59,999),
      icons: {
        time: "fas fa-clock",
        date: "fa fa-calendar",
        up: "fa fa-arrow-up",
        down: "fa fa-arrow-down",
        previous: "fa fa-chevron-left",
        next: "fa fa-chevron-right",
        today: "fas fa-clock",
        clear: "fa fa-trash-o"
      }
    }).on('dp.change', function(e){
      $('#start_date').data("DateTimePicker").maxDate(e.date);
    });

    // Initialize datepicker for ingredients expiry date - disallow past dates
    $('.datetimepicker-future').datetimepicker({
      format: 'MM/DD/YYYY',
      minDate: new Date(),
      icons: {
        date: "fa fa-calendar",
        up: "fa fa-arrow-up",
        down: "fa fa-arrow-down",
        previous: "fa fa-chevron-left",
        next: "fa fa-chevron-right",
        today: "fas fa-clock",
        clear: "fa fa-trash-o"
      }
    });
  });

  setupPercentageField = () => {
    $(document).on('focusin', '.percentageField', function(){
      $(this).val($(this).val().replace('%', ''))
    })

    $(document).on('focusout', '.percentageField', function(){
      if ($(this).val().length == 0) {
        $(this).val($(this).val() + '0%')
      } else if($(this).val().length >= 0 ) {
        $(this).val($(this).val() + '%')
      }
    })

    $(document).on('keypress', '.percentageField', function(event){
      var key = event.keyCode;
      return (key >= 48 && key <= 57) || ((!$(this).val().includes('.')) && key == 46)
    });
  }

  removePercentage = () => {
    $('.percentageField').each(function() {
      $(this).val($(this).val().replace('%', ''));
    })
  }

  setupPercentageField();
  removePercentage();

  setupDollarField = () => {
    $(document).on('focusin', '.dollarField', function(){
      $(this).val($(this).val().replace('$', ''))
    })

    $(document).on('focusout', '.dollarField', function(){
      if ($(this).val().length == 0) {
        $(this).val('$' + $(this).val() )
      } else if($(this).val().length >= 0 ) {
        $(this).val('$' + $(this).val())
      }
    })

    $(document).on('keypress', '.dollarField', function(event){
      var key = event.keyCode;
      return (key >= 48 && key <= 57) || ((!$(this).val().includes('.')) && key == 46)
    });
  }

  removeDollar = () => {
    $('.dollarField').each(function() {
      $(this).val($(this).val().replace('$', ''));
    })
  }

  setupDollarField();
  removeDollar();

  debounce = (fn, delay) => {
    var timer = null;
    return function () {
        var context = this,
            args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
  };

  debounce();

  $(document).on('keyup', '.form-control', function(){
    var field = $(this);
    var $field = $(field) || field;
    if ($field.siblings('.message').length > 0) {
      $field.parent().prev('.field_with_errors').find('label').unwrap();
      $field.unwrap();
      $field.next('.message').remove();
      return true;
    }
    return false;
  })
  $(document).on('input', '.item-quntity', function () {
    var item_key = $(this).data('item-key');
    var item_id = $(this).data('item-id');
    var variation_id = $('.' + item_key + '_variation').val();
    var taxes = $('.' + item_key + '_taxes').val();
    var discounts = $('.' + item_key + '_discounts').val();
    var modifiers = $('.' + item_key + '_modifiers').val();
    var quantity = $(this).val();
    var is_manual_item = "false";
    var price = $(this).data('item-price');
    var category_id = $(this).data('item-category-id');
    if (item_id == "1"){
      is_manual_item = "true";
    }
      $.ajax({
        url: '/invoices/update_item_data',
        type: "POST",
        data: {
        "item[item_id]":  item_id,
        "item[variation_id]": variation_id,
        "item[taxes]": taxes,
        "item[discounts]": discounts,
        "item[modifiers]": modifiers,
        "item[quantity]": quantity,
        "item[item_key]": item_key,
        "item[is_manual_item]": is_manual_item,
        "item[price]": price,
        "item[category_id]": category_id
      },
        dataType: 'script'
      }); 
  })

  $(document).on('click', '.refresh_kitchen', function(){
    location.reload();
  })

  // chnages for if the item has price_type== veriable 
  $(document).on('change', ' .price-field', function () {
    var item_key = $(this).data('item-key');
    var item_id = $(this).data('item-id');
    var variation_id = $('.' + item_key + '_variation').val();
    var taxes = $('.' + item_key + '_taxes').val();
    var discounts = $('.' + item_key + '_discounts').val();
    var modifiers = $('.' + item_key + '_modifiers').val();
    var quantity  = $(this).closest('tr').find('.item-quntity').val();
    var is_manual_item = "false";
    var price = $(this).val();
    var category_id = $(this).data('item-category-id');
    if (item_id == "1"){
      is_manual_item = "true";
    }

    console.log( "after chnage object ", {
    item_key: item_key,
    item_id: item_id,
    variation_id: variation_id,
    taxes: taxes,
    discounts: discounts,
    modifiers: modifiers,
    quantity: quantity,
    price: price,
    category_id: category_id,
    is_manual_item: is_manual_item
  });
      $.ajax({
        url: '/invoices/update_item_data',
        type: "POST",
        data: {
        "item[item_id]":  item_id,
        "item[variation_id]": variation_id,
        "item[taxes]": taxes,
        "item[discounts]": discounts,
        "item[modifiers]": modifiers,
        "item[quantity]": quantity,
        "item[item_key]": item_key,
        "item[is_manual_item]": is_manual_item,
        "item[price]": price,
        "item[category_id]": category_id
      },
        dataType: 'script'
      }); 
  })

  $(document).on('click', '.refresh_kitchen', function(){
    location.reload();
  })
  // "Orders Open" on the KDS, recounted from the tickets on screen. Kept here so the live
  // updates word the count the same way the page does on load ("22 Orders Open", not "22 Open").
  window.updateKdsOrderCount = function (){
    var openOrders = $.unique($.map($('.OrderCard'), function (element) {
      return $(element).data('id')
    })).length;
    $('.orderCount').html(openOrders + (openOrders === 1 ? ' Order' : ' Orders') + ' Open');
  }

  window.setLiquidDesign = function (){
    var delay_required = true
    // if($('#isLiquidDesign').val() == 'yes'){    
      var columns = parseInt($(window).width() / 350);

      var card_width = 350;

      remain_space = ($('#orderListing').width() % 350) - (30 * (columns - 1));
      card_width =  parseInt(350 + (remain_space/columns));

      if(card_width < 350){
        card_width = 350;
      }
      if(delay_required){
        // setTimeout( function(){ 
        //   $('#orderListing').masonry({
        //     itemSelector: '.OrderCard',
        //     columnWidth: 0
        //   });
        // }  , 1000);
      }
      else{
        // $('#orderListing').masonry({
        //   itemSelector: '.OrderCard',
        //   columnWidth: 0
        // });
      }
    // }
    // else{
    //   setHeightIfStaticDesign();
    // }
    $('.OrderCard').css('transform', 'none');

    // logic to display elements in sorted format
      var divids = []
    $("#orderListing .OrderCard").each(function (index, element) {
      divids.push($(element).attr('data-sort-id'))
    })
    
    var orders_sort_by_time = $('#orders_sort_by_time').val();
    if (orders_sort_by_time == "by_order_asc" || orders_sort_by_time == "by_time_desc") {
      $.each(divids.sort(), function (index, element) {
        var elem = $("[data-sort-id='" + element + "']");
        elem.remove();
        $(elem).appendTo("#orderListing");
      });
    } else {
      $.each(divids.sort().reverse(), function (index, element) {
        var elem = $("[data-sort-id='" + element + "']");
        elem.remove();
        $(elem).appendTo("#orderListing");
      });
    }
  }
  $(document).on('click', 'li.selection', function(){
    select_class = $(this).data('class')
    dropdown_class = "ModifierGroup"
    var inv_ids = [];
    if ($(this).hasClass("selected")){
      title = $(this).data('name')
      setId = select_class+"_"+$(this).data('value')
      price = $(this).data('price')
      price = parseFloat(price).toFixed(2);
      setId = select_class+"_"+$(this).data('value');
      modifierSetId = $(this).data('value');
      maximum_modifier = $("#maximum_modifier_" + modifierSetId).val()
      static_html = "";
      
      inv_ids.push($('#ModifierGroup_').val());
      inv_ids.push($(this).data('value'));
      $('#ModifierGroup_').val(inv_ids);
      // static_html = '<div class="item-list d-flex align-items-center justify-content-between pb-0 item_'+setId+'" id="'+setId+'"><i class="fa fa-bars sorting-handler"  style="width: 156px;" aria-hidden="true"></i><input type="hidden" name="item[modifier_set_sort][]" id="item_modifier_set_sort_'+modifierSetId +'" value="'+modifierSetId +'" class="item-modifier-set-sort" data-modifier-set-id="'+modifierSetId+'"><p style="width: 100%;" class="fs-14 text-center">'+title+'</p><div class="col-3"><div class="col-input dropdown_box"><div><p class="fs-12">Minimum Modifier</p><input type="text" name="item_modifier_sets['+ modifierSetId +'][required_modifier]" id="item_modifier_sets_'+modifierSetId+'_required_modifier" value="0" class="form-control minimum-modifier selected_min_modifier_'+modifierSetId+'"'+'max="'+maximum_modifier+'" data-parsley-max-message="Maximum alllowed modifier is '+maximum_modifier+'" data-modifier-set-id="'+modifierSetId+'"data-parsley-errors-container="#minimum-modifier-'+modifierSetId+'"></div></div></div><div class="col-3"><div class="col-input dropdown_box"><div><p class="fs-12">Maximum Modifier</p><input type="text" name="item_modifier_sets['+modifierSetId+'][maximum_modifier]" id="item_modifier_sets_'+modifierSetId+'_maximum_modifier" value="0" class="form-control maximum-modifier selected_max_modifier_'+modifierSetId+'" max="'+maximum_modifier+'" data-parsley-max-message="Maximum alllowed modifier is '+maximum_modifier+'" data-modifier-set-id="'+modifierSetId+'"data-parsley-errors-container="#maximum-modifier-'+modifierSetId+'"></div></div></div><div class="action-area pl-2" style="width: 25%;"><a href="javascript:;" class="remove" id="'+setId+'" data-id="'+$(this).data('value')+'"><img src="/packs/media/images/basic_logos/delete-8b50938d1bdfeb75aca5e3e4a5765bec.svg" alt="" /></a></div></div><div class="row"><div class="col-5 p-0"></div><div id="minimum-modifier-'+modifierSetId+'" class="col-3" style="max-width: 23%"></div><div id="maximum-modifier-'+modifierSetId+'" class="col-3"></div><div class="col-1 p-0"></div></div>'
      static_html = `<div class="item-list d-flex align-items-center justify-content-between pb-0 item_${setId}" id="${setId}">
                        <i class="fa fa-bars sorting-handler" style="width: 156px;" aria-hidden="true"></i>
                        <input type="hidden"
                              name="item[modifier_set_sort][]"
                              id="item_modifier_set_sort_${modifierSetId}"
                              value="${modifierSetId}"
                              class="item-modifier-set-sort"
                              data-modifier-set-id="${modifierSetId}">

                        <p style="width: 100%;" class="fs-14 text-center">${title}</p>
                        <div class="col-6" style="width: 50%; display: flex; gap:20px">
                        <!-- Minimum Modifier -->
                        <div style="width: 50%">
                          <div class="col-input dropdown_box">
                            <div>
                              <p class="fs-12">Minimum Modifier</p>
                              <input type="number"
                                    name="item_modifier_sets[${modifierSetId}][required_modifier]"
                                    id="item_modifier_sets_${modifierSetId}_required_modifier"
                                    value="0"
                                    class="form-control minimum-modifier numeric-only selected_min_modifier_${modifierSetId}"
                                    max="${maximum_modifier}"
                                    data-parsley-max-message="Maximum allowed modifier is ${maximum_modifier}"
                                    data-modifier-set-id="${modifierSetId}"
                                    data-parsley-errors-container="#minimum-modifier-${modifierSetId}">
                            </div>
                          </div>
                        </div>

                        <!-- Maximum Modifier -->
                        <div style="width: 50%">
                          <div class="col-input dropdown_box">
                            <div>
                              <p class="fs-12">Maximum Modifier</p>
                              <input type="number"
                                    name="item_modifier_sets[${modifierSetId}][maximum_modifier]"
                                    id="item_modifier_sets_${modifierSetId}_maximum_modifier"
                                    value="0"
                                    class="form-control maximum-modifier numeric-only selected_max_modifier_${modifierSetId}"
                                    max="${maximum_modifier}"
                                    data-parsley-max="${maximum_modifier}"
                                    data-parsley-max-message="Maximum allowed modifier is ${maximum_modifier}"
                                    data-modifier-set-id="${modifierSetId}"
                                    data-parsley-errors-container="#maximum-modifier-${modifierSetId}"
                                    data-parsley-errors-messages-disabled="true">
                                     <p id="maximum-modifier-${modifierSetId}-custom" class="text-danger d-none"style="font-size:12px; line-height: 1.4; margin-top:5px;"></p>
                            </div>
                          </div>
                        </div>
                        </div>

                        <!-- Delete Button -->
                        <div class="action-area pl-2" style="width: 25%;">
                          <a href="javascript:;" class="remove" id="${setId}" data-id="${$(this).data('value')}">
                            <img src="/packs/media/images/basic_logos/delete-8b50938d1bdfeb75aca5e3e4a5765bec.svg" alt="" />
                          </a>
                        </div>
                      </div>
                      <!-- Error Containers -->
                      <div class="row">
                        <div class="col-5 p-0"></div>

                        <div id="minimum-modifier-${modifierSetId}" class="col-3" style="max-width: 23%"></div>

                        <div id="maximum-modifier-${modifierSetId}" class="col-3 text-danger" style="font-size:12px; line-height: 1.4; margin-top:5px;"></div>

                        <div class="col-1 p-0"></div>
                      </div>
                      `;
      $(".item-list-wrap."+select_class).append(static_html)
    }else{
      cbx_class = select_class+"_"+$(this).data('value')
      
      $(".item_"+cbx_class).remove()
      $(".item-list."+cbx_class).remove()
    } 
  })
  $(document).on('click', '.remove', function(){
    id = $(this).attr('id')
    console.log("xxxxxxxxxxx",id)
    // unchecked_checkbox(id)
    $("#"+id).remove();
    $("input."+id).click();
    $("."+id).prop('checked', false)
    $("."+id).removeClass('selected')
    updateIndex();
  })
  window.updateIndex = function(){
    reorder_ids = [];
    $.each($('.remove'), function(ind, elem){
      reorder_ids.push($(elem).attr('data-id'));
    });
    $('#ModifierSet_').val(reorder_ids);
  }
